<template>
  <v-dialog v-model="opened" content-class="confirm-dialog" max-width="350">
    <h3 class="confirm-dialog__title">
      {{ title || $t('common.areYouShure') }}
    </h3>

    <div class="d-flex justify-space-between">
      <v-btn width="150" outlined @click="opened = false">
        {{ $t('common.btns.cancel') }}
      </v-btn>
      <v-btn
        width="150"
        color="warning"
        elevation="0"
        @click="
          () => {
            $emit('confirm');
            opened = false;
          }
        "
      >
        {{ $t('common.btns.ok') }}
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    title: {
      type: String,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
</script>

<style lang="scss">
.confirm-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    text-align: center;
    color: #464646;
    font-size: 20px;
    margin-bottom: 15px;
  }
}
</style>
